/* eslint-disable */
export enum SortedType {
  MOST_RECENT = 0,
  ALPHABETICAL,
  OLDEST
}
